import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'

export default function GoogleAdsInputContainer({
	value,
	content,
	AdType,
	sectionTypeLock,
	setSectionData,
	isLocked,
	handleLocks,
	setInputText,
	setSelectedLanguage
}) {
	const [responseValue, setResponseValue] = useState("");
	const [isEditing, setIsEditing] = useState(false); 
	const handleContentEdit = () => {
		setIsEditing(true);
	}
	const handleSaveContent = () => {
		setSectionData((prevState) => {
			const sectionDataCopy = { ...prevState };
			if(value === null)
				sectionDataCopy.googleAds.carouselAd["Headlines"] = responseValue;
			else if(sectionTypeLock === "descriptionsLock")
				sectionDataCopy.googleAds[AdType]["Descriptions"][value] = responseValue;
			else if(sectionTypeLock === "headlinesLock")
				sectionDataCopy.googleAds[AdType]["Headlines"][value] = responseValue;
			else
				sectionDataCopy.googleAds[AdType]["Long_Headlines"][value] = responseValue;
			return sectionDataCopy;
		})
		setIsEditing(false);
	}
	const handleEditChange = (e) => {
		setResponseValue(e.target.value);
	};

  return (
	<div className='p-1.5 min-h-[2.3rem] w-[100%] bg-white rounded-lg mt-2 flex justify-between border-2 border-gray-250 whitespace-normal'>
		{
			isEditing ? (
				<TextField
					variant="standard"
					fullwidth
					multiline
					defaultValue={content}
					onChange={handleEditChange}
					InputProps={{
						disableUnderline: true,
					}}
					inputRef={(input) => input && input.focus()}
					onFocus={(e) =>
						e.currentTarget.setSelectionRange(
							e.currentTarget.value.length,
							e.currentTarget.value.length
						)
					}
				/>
			) : (
				<p className='whitespace-normal'>{content}</p>
			)
		}
		<div className='flex'>
			{
				isEditing ? 
				(
					<Button>
						<img
							className='h-[1.2rem] w-[1.2rem]'
							src={require(`../assets/saveIcon.png`)}
							alt="save-Icon"
							onClick={handleSaveContent}
						/>
					</Button>
				) : (
					<Button>
						<img
							className='h-[1.2rem] w-[1.2rem]'
							src={require(`../assets/edit-icon.png`)}
							alt="edit-Icon"
							onClick={handleContentEdit}
						/>
					</Button>
				)
			}
			{
				isEditing ? 
				(
					<Button>
						<img
							className='h-[1.2rem] w-[1.2rem]'
							src={require(`../assets/disabledLock.png`)}
							alt="disabled-locked-Icon"
						/>
					</Button>
				) : (
					<Button>
						<img
							className='h-[1.2rem] w-[1.2rem]'
							src={
								isLocked
								? require(`../assets/content-lock.jpg`) 
								: require(`../assets/content-unlock.jpg`)
							}
							onClick={() => handleLocks(AdType, sectionTypeLock, value)}
							alt="locked-Icon"
						/>
					</Button>
				)
			}
			{
				isEditing ? 
				(
					<Button>
						<img
							className='h-[1.2rem] w-[1.2rem]'
							src={require("../assets/disabledTranslate.png")}
							alt="disabled-send-to-translate"
						/>
					</Button>
				) : (
					<></>
				)
			}
		</div>
	</div>
  )
}
